if (!customElements.get('amanjeda-search')) {
  customElements.define('amanjeda-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.search--textbox');
      this.results = this.querySelector('.search--results');
      this.clearButton = this.querySelector('.search--clear');
      this.status = this.querySelector('[data-search-status]');
      this.fallback = this.querySelector('[data-search-fallback]');
      this.cache = new Map([['', this.results.innerHTML]]);
      this.version = 0;
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.input.addEventListener('input', () => this.onInput(), options);
      this.clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.onInput();
        this.input.focus();
      }, options);
      this.addEventListener('keydown', event => this.onKeydown(event), options);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      clearTimeout(this.timer);
      this.version++;
    }

    onInput() {
      clearTimeout(this.timer);
      this.request?.abort();
      const version = ++this.version;
      const query = this.input.value.trim();
      this.clearButton.hidden = !query;
      this.fallback.hidden = true;
      this.status.textContent = '';
      this.setAttribute('aria-busy', 'false');
      if (this.cache.has(query)) {
        this.render(this.cache.get(query));
        return;
      }
      this.timer = setTimeout(() => this.search(query, version), 200);
    }

    async search(query, version) {
      this.request = new AbortController();
      this.setAttribute('aria-busy', 'true');
      const url = new URL(this.dataset.suggestUrl, location.origin);
      url.search = new URLSearchParams({
        q: query,
        section_id: 'predictive-search',
        'resources[type]': 'product,article,page,collection,query',
        'resources[limit]': '8',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,body,tag'
      }).toString();
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = document.querySelector('#shopify-section-predictive-search');
        if (!section) throw new Error('Search unavailable');
        if (version !== this.version) return;
        if (this.cache.size >= 20) this.cache.delete([...this.cache.keys()].find(key => key !== ''));
        this.cache.set(query, section.innerHTML);
        this.render(section.innerHTML);
      } catch (error) {
        if (error.name === 'AbortError' || version !== this.version) return;
        this.results.innerHTML = '';
        this.status.textContent = this.dataset.error;
        const fallback = new URL(this.querySelector('form').action, location.origin);
        fallback.search = new URLSearchParams({ q: query, type: 'product,article,page', 'options[prefix]': 'last' }).toString();
        this.fallback.href = fallback.pathname + fallback.search;
        this.fallback.hidden = false;
      } finally {
        if (version === this.version) this.setAttribute('aria-busy', 'false');
      }
    }

    render(html) {
      this.results.innerHTML = html;
      this.status.textContent = this.results.querySelector('[data-search-summary]')?.textContent || '';
      window.dispatchEvent(new CustomEvent('theme:search:reloaded'));
      window.dispatchEvent(new CustomEvent('theme:transition:reload:search'));
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.querySelector('[data-drawer-close]').click();
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const links = [...this.results.querySelectorAll('a[href], button:not([disabled])')]
        .filter(link => link.getClientRects().length);
      if (!links.length) return;
      const index = links.indexOf(document.activeElement);
      if (document.activeElement !== this.input && index < 0) return;
      event.preventDefault();
      const next = event.key === 'ArrowDown' ? index + 1 : index < 0 ? links.length - 1 : index - 1;
      if (next < 0 || next >= links.length) this.input.focus();
      else links[next].focus();
    }
  });
}
